var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSidebar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#5C5F62",
  d: "M8.007 8.619a.862.862 0 1 0 0-1.724.862.862 0 0 0 0 1.724M5.315 8.619a.862.862 0 1 0 0-1.724.862.862 0 0 0 0 1.724M10.702 8.619a.862.862 0 1 0 0-1.725.862.862 0 0 0 0 1.725M2.624 5.758.947 7.405a.504.504 0 0 0 0 .71l1.677 1.66a.504.504 0 0 0 .862-.357V6.116a.504.504 0 0 0-.862-.358M13.393 9.77l1.66-1.643a.5.5 0 0 0 0-.71l-1.66-1.66a.5.5 0 0 0-.862.353v3.302a.505.505 0 0 0 .862.357"
})));
export default SvgSidebar;